import { Help as HelpIcon } from '@mui/icons-material';

import { useTrans } from "~/hooks/useTrans";
import ButtonLink from "~/components/ButtonLink";
import ExternalLink from "~/components/ExternalLink";

import "./style.less";

interface IWhatAbout {
	title?: string;
	link?: string;
	onClick?: () => void;
}

export default function WhatAbout({
	title = "",
	link = "",
	onClick = () => {},
}: IWhatAbout) {
	const { trans } = useTrans();

	function getContent() {
		return <>
			<HelpIcon sx={{ fill: "var(--dark-green-text-color)", width: "24px", height: "24px" }} />
			{ title || trans("tariffWhatAbout.title") }
		</>;
	}

	return <>
		{ link === "" && <ButtonLink className="whatAbout__btn" title={<>
			{ getContent() }
		</>} onClick={onClick} />}
		{ link.length > 0 && <ExternalLink to={link} className="whatAbout__link">
			{ getContent() }
		</ExternalLink> }
	</>;
}
